module.exports = __webpack_public_path__ + "static/media/F-3-mobile.0b14dd58.webp";